module.exports = __webpack_public_path__ + "static/media/loading.272baf8c.svg";